export default __webpack_public_path__ + "static/media/1l.7abe07e3.svg";